import GoodsInStatus from "./GoodsInStatus";

export default GoodsInStatus;
